import { Navigate } from 'react-router-dom';
import Page404 from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Page404';
import Page500 from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Page500';
import theme from '@monorepo/shared/src/themes/studentAppTheme';
import { isQA } from '@monorepo/shared/src/config';
import { RouteConfig } from '@monorepo/shared/src/types';
import Assignments from 'components/modules/Assignments';
import Activities from 'components/modules/Activities';
import Home from 'components/modules/Home';
import LetterBooks from 'components/modules/LetterBooks';
import OnboardingTour from 'components/modules/Tours/Onboarding';
import Sandbox from 'components/layout/Sandbox';
import StickerWall from 'components/modules/Rewards/StickerWall';
import SelectSticker from 'components/modules/Rewards/SelectSticker';
import Reports from 'components/modules/ForFamilies/Reports';
import FamilyResources from 'components/modules/ForFamilies/FamilyResources';
import ActivityCompletion from 'components/modules/Activities/components/ActivityCompletion';
import ReadBook from 'components/modules/ReadBook';

export const routes: RouteConfig[] = [
  {
    path: '/404',
    component: Page404,
    defaultComponentProps: { theme: theme.palette.secondary.dark },
    isPrivate: false,
    backgroundColor: '#F4F4F4',
    getTitle: () => '404 Not Found',
  },
  {
    path: '/oops',
    component: Page500,
    defaultComponentProps: { theme: theme.palette.secondary.dark },
    isPrivate: false,
    backgroundColor: '#F4F4F4',
    getTitle: () => '500 Internal Server Error',
  },
  {
    path: '/',
    component: Navigate,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Home',
    to: '/home',
    replace: true,
  },
  {
    path: '/home',
    component: Home,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Home',
  },
  {
    path: '/assignments',
    component: Assignments,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Activities',
  },
  {
    path: '/assignments/:assignmentId',
    component: Assignments,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Activities',
  },
  {
    path: '/assignment-activities/:assignmentActivityId',
    component: Activities,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Activities',
  },
  {
    path: '/letter-books',
    component: LetterBooks,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Letter Books',
  },
  {
    path: '/read-book/:bookCode',
    component: ReadBook,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Letter Books',
  },
  {
    path: '/rewards',
    component: StickerWall,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Rewards',
  },
  {
    path: '/rewards/:character',
    component: SelectSticker,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Stickers',
  },
  {
    path: '/reports',
    component: Reports,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Reports',
  },
  {
    path: '/reports/:character',
    component: Reports,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Reports',
  },
  {
    path: '/family-resources',
    component: FamilyResources,
    isPrivate: true,
    backgroundColor: '#F4F4F4',
    getTitle: () => 'Reports',
  },
  {
    path: '/tour/onboarding',
    component: OnboardingTour,
    isPrivate: true,
    getTitle: () => 'Tour',
  },
  {
    path: '/activity-complete/:assignmentActivityId',
    component: ActivityCompletion,
    isPrivate: true,
    getTitle: () => 'Activity Completion',
  },
  ...(isQA(process.env.REACT_APP_BUILD_ENV as string)
    ? [
        {
          getTitle: () => 'Sandbox',
          path: '/sandbox',
          component: Sandbox,
          isPrivate: true,
        },
        {
          path: '/test-activities',
          component: Activities,
          isPrivate: true,
          backgroundColor: '#F4F4F4',
          getTitle: () => 'Activities',
        },
        {
          path: '/test-activities/:activityName',
          component: Activities,
          isPrivate: true,
          backgroundColor: '#F4F4F4',
          getTitle: () => 'Activities',
        },
      ]
    : []),
];
